import React from "react";
import formatUrl from "utils/FormatUrl";
import style from "./Item.module.css";

function Item(props) {
  return (
    <div className={style.jeCalculeContainer}>
      <div>
        <img
          src={props.image}
          alt={props.title}
          width={props.width}
          height={props.height}
        />
      </div>
      <div className={style.actionSection}>
        <p className={style.title}>{props.title}</p>
        <div className={style.textes}>
          <p className={style.description}>{props.description}</p>
          <p className={style.description}>{props.description2}</p>
        </div>
        {/* <button className={style.button}> */}
        <a
          href={formatUrl(props.button_link, props.lang)}
          rel={
            props.button_link?.includes("list") ||
            props.button_link?.includes("map") ||
            props.button_link?.includes("?") ||
            props.button_link?.includes("conditions") ||
            props.button_link?.includes("contact")
              ? "noindex, nofollow, noreferrer"
              : "dofollow"
          }
          target="_blank"
          className={style.button}
        >
          {props.buttonText}
        </a>
        {/* </button> */}
      </div>
    </div>
  );
}

export default Item;
